import {
  BaSeAutocomplete,
  BaSeButton,
  BaSeDialogContext,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useMessage } from '../../../../../../hooks/messages/useMessage';
import { useInterviewService } from '../../../../../../hooks/services/interview-service';
import { useUserService } from '../../../../../../hooks/services/user-service';
import ConfirmContentIncludeResponsability from './confirm-content-inclusion';
import ConfifmSelfInclude from './confirm-self-include';
import { AlignButtonsLeft, Container } from './find-manager-by-name-style';

function FindManagerByName({ closeModal, isOwner, idInterview, reloadData }) {
  const { showModal } = React.useContext(BaSeDialogContext);
  const { handleError, handleSuccess } = useMessage();
  const [selectedItem, setSelectedItem] = React.useState();

  const { getManagersByName } = useUserService();
  const { addManagerResponsability } = useInterviewService();

  const handleAutompleteSearchTerm = React.useCallback(
    async (term) => {
      const response = await getManagersByName({
        pageIndex: 0,
        pageSize: 100,
        nameSearch: term,
        idInterview,
      });

      const responseFormated = response.items.map((item) => {
        return {
          ...item,
          id: item.id,
          label: item.name,
        };
      });

      return responseFormated;
    },
    [getManagersByName, idInterview],
  );

  const confirmInclude = React.useCallback(
    async (idInterview, idMnagerResponsible, action) => {
      addManagerResponsability({ idInterview, idMnagerResponsible })
        .then(() => {
          handleSuccess('Inclusão efetuada com sucesso!');
          reloadData();
        })
        .catch((error) => {
          handleError(error.message);
        })
        .finally(() => {
          closeModal();
          action();
        });
    },
    [
      addManagerResponsability,
      handleError,
      handleSuccess,
      closeModal,
      reloadData,
    ],
  );

  const openDialogConfirm = React.useCallback(
    (title, term) => {
      return showModal({
        actions: [],
        size: 'medium',
        title: `${title}`,
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => {
          if (term === 'add') {
            return (
              <ConfirmContentIncludeResponsability
                data={{ idInterview, idMnagerResponsible: selectedItem.id }}
                confirmInclude={confirmInclude}
                closeModal={closeModal}
              />
            );
          }
          return (
            <ConfifmSelfInclude
              idInterview={idInterview}
              confirmInclude={confirmInclude}
              closeModal={closeModal}
            />
          );
        },
      });
    },
    [confirmInclude, idInterview, selectedItem, showModal],
  );

  return (
    <Container>
      <BaSeParagraph>
        Informe o nome do gestor que também irá acompanhar o progresso deste
        candidato ou caso deseje você mesmo acompanhar, clique em{' '}
        <strong>"Me incluir"</strong>.
      </BaSeParagraph>

      <div style={{ height: '200px' }}>
        <BaSeAutocomplete
          complement=""
          helpButtonProps={{
            direction: 'right',
            message: 'Texto de ajuda',
          }}
          inputMode="search"
          label="Nome do Gestor"
          minLengthToSearch={1}
          mode="list"
          onSearchTerm={handleAutompleteSearchTerm}
          onSelectedItem={(item) => {
            setSelectedItem(item);
          }}
          onClearSelection={() => setSelectedItem(undefined)}
          placeholder="Nome"
          size="medium"
          subLabel=""
          width="100%"
        />
      </div>
      <AlignButtonsLeft>
        <BaSeButton
          value="Adicionar"
          color={BaSeTheme.colors.defaultColors.black}
          onClick={() => {
            if (selectedItem === undefined) {
              handleError('Informe o Gestor responsável.');
              return;
            }
            openDialogConfirm('Confirmar gestor responsável', 'add');
          }}
        />
        <BaSeButton
          value="Me incluir"
          type="secondary"
          isDisabled={isOwner}
          onClick={() => openDialogConfirm('Me incluir', 'self')}
        />
      </AlignButtonsLeft>
    </Container>
  );
}

export default FindManagerByName;
